<script lang="ts">
    import {getContext, onDestroy} from 'svelte';
    import type {Writable} from 'svelte/store';
    import {getValueEditorLabelContext} from './value-editor-label-context';
    import {isFunction} from '../../../shared/utils/custom-utils';

    /*
    headless-ui does not allow using custom ids for its elements,
    and it manages aria-labelledby attributes, preventing us doing it manually.
    it also does not allow for custom label to be outside its container component
    to provide correct label information for main inputs build with headless-ui,
    we need to tap its internal API via svelte context.
    basically this component acts as headless-ui label component,
    but instead of rendering label it registers id of our existing label element
    * */

    const LABEL_CONTEXT_NAME = 'headlessui-label-context';
    const contextStore: Writable<any> = getContext(LABEL_CONTEXT_NAME);
    if (!contextStore) {
        throw new Error(
            'You used a <LabelIdProvider /> (replacement for headless-ui\'s native <Label />) component, ' +
            'but it is not inside a relevant parent.'
        );
    }

    const labelContext = getValueEditorLabelContext();

    let subscription;
    if(!!labelContext) {

        $contextStore?.register(labelContext.labelId);
        const clickHandler: unknown = $contextStore?.props?.onClick;
        labelContext.config.update((currentConfig) => ({...currentConfig, disableForAttribute: true}));

        if (isFunction(clickHandler)) {
            subscription = labelContext.clickEvent$.subscribe(() => clickHandler());
        }
    }

    onDestroy(() => {
        subscription?.unsubscribe();
    });
</script>

